export const COMPANY_KEY = "companyData";
export const CLIENT_FORM_KEY = "clientNewForm";
export const CLIENTS_KEY = "clients";
export const PRODUCTS_KEY = "products";
export const PRODUCT_FORM_KEY = "productNewForm";
export const APP_CONTEXT = "appContext";
export const INVOICES_KEY = "invoices";
export const INVOICE_DETAILS = "invoiceDetailList";
export const INVOICE_FORM_KEY = "invoiceNewForm";
export const DEFAULT_INVOICE_COLOR = "defaultInvoiceColor";
export const DEFAULT_INVOICE_BG = "defaultInvoiceBG";
export const QUOTATIONS_KEY = "quotations";
export const QUOTATION_DETAILS = "quotationDetailList";
export const QUOTATION_FORM_KEY = "quotationNewForm";
export const DEFAULT_QUOTATION_COLOR = "defaultQuotationColor";
export const DEFAULT_QUOTATION_BG = "defaultQuotationBG";
